import EmberObject from '@ember/object';

export function computeFromComponentValues(c1, c2, r1, r2, r3, r4) {
  var gain = 1 + r4 / r3;
  var sqrtTerm = Math.sqrt(r1 * r2 * c1 * c2);
  var fpPrime = 1 / (2 * Math.PI * sqrtTerm);
  var d1 = r1 * c2;
  var d2 = r2 * c2;
  var d3 = r1 * c1;
  var q = sqrtTerm / (d1 + d3 + d2 * (1 - gain));
  var fp = fpPrime;

  var result = EmberObject.create({ stageQ: q, stageFp: fp, gain: gain });
  return result;
}

export function execute(circuit) {
  var r1 = circuit.r1.value;
  var r2 = circuit.r2.value;
  var r3 = circuit.r3.value;
  var r4 = circuit.r4.value;
  var c1 = circuit.c1.value;
  var c2 = circuit.c2.value;
  return this.computeFromComponentValues(c1, c2, r1, r2, r3, r4);
}
